import { useState } from 'react'
import './navbar.css'
import logo from '../../assets/logo.svg'
import BurgerButton from '../BurgerButton'


function Navbar() {
  const [clicked, setClicked] = useState(false)
  const handleClick = () => {
    setClicked(!clicked)
  }
  
  return (
    <div className="navbar">
      <a href="/">
      <img  src={logo} alt="" />
      </a>
        <div className={`links ${clicked ? 'active' : ''}`}>          
                    <a href="/">Home</a>
                    <a href="/menu">Explore Food</a>
                    <a href="/about">About us</a>
                    <a href="/contact">Contact</a> 
                </div>
          <div className="burger">
            <BurgerButton clicked ={clicked} handleClick={handleClick} />
          </div>
          <bgDiv className={`initial ${clicked ? 'active' : ''}`}></bgDiv>
    </div>
  )
}

export default Navbar